import styled from '@emotion/styled';
import { cx } from '@emotion/css';
import { useGetRegionLabel } from 'hooks/business/useRegion';
import checkedSvg from '../assets/checked-blue.svg';

interface RegionCheckboxProps {
  options: General.UpperCaseRegion[];
  value?: General.UpperCaseRegion;
  onChange?: (value: General.UpperCaseRegion) => void;
  disabledOptions?: General.UpperCaseRegion[];
}

export const RegionCheckbox = (props: RegionCheckboxProps) => {
  const { options, value, onChange, disabledOptions = [] } = props;
  const getRegionLabel = useGetRegionLabel();

  return (
    <>
      {options.map((region) => {
        const disabled = disabledOptions.includes(region);
        return (
          <RegionTag
            className={cx(region === value ? 'checked' : '', disabled ? 'disabled' : '')}
            key={region}
            onClick={() => {
              if (disabled) return;
              onChange?.(region);
            }}
          >
            <img
              alt={region}
              src={`${process.env.PUBLIC_URL}/country-flag-icons/${region?.toUpperCase()}.svg`}
            />
            <span>{getRegionLabel(region)}</span>
          </RegionTag>
        );
      })}
    </>
  );
};

const RegionTag = styled.div`
  display: inline-block;
  height: 32px;
  line-height: 32px;
  padding: 0 10px 0 8px;
  margin-bottom: 16px;
  margin-right: 16px;
  border: 1px solid var(--fett-border-strong);
  cursor: pointer;

  &:hover,
  &.checked {
    border-color: var(--ant-primary-color);
    color: var(--ant-primary-color);
  }
  &.checked {
    background: url(${checkedSvg}) no-repeat right bottom;
  }
  &.disabled {
    color: var(--fett-text-secondary);
    opacity: 0.4;
    cursor: not-allowed;

    &:hover {
      border-color: var(--fett-border-strong);
      color: var(--fett-text-secondary);
    }
  }

  & > img {
    width: 16px;
    margin-right: 6px;
    vertical-align: baseline;
  }
`;
